import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Column } from '../../../Layout';
import styles from '../table.module.scss';
export function TableSurface(param) {
    let { scrollerRef, onScroll, framed, interactive = true, scrollable = true, hasRowsBelow = false, children, testId } = param;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 0,
        className: cn(styles.surface, {
            [styles.uncappedHeight]: !scrollable
        }),
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: scrollerRef,
                className: cn(styles.scroller, {
                    [styles.fixedWidth]: !scrollable
                }),
                tabIndex: 0,
                onScroll: onScroll,
                "data-scroller": true,
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table, {
                        [styles.unifiedTable]: framed,
                        [styles.staticTable]: !interactive
                    }),
                    children: children
                })
            }),
            scrollable && /*#__PURE__*/ _jsx("div", {
                "aria-hidden": true,
                className: cn(styles.bottomFade, {
                    [styles.hidden]: !hasRowsBelow
                }),
                "data-testid": testId == null ? undefined : "".concat(testId, "-bottom-fade")
            })
        ]
    });
}
